import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Box } from '../Box';
import './Pill.css';
export const Pill = forwardRef(function Pill(props, ref) {
    const { children, className, variant = 'neutral', size, ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, elementType: "span", className: clsx('mollie-ui-pill', {
            [`mollie-ui-pill--${variant}`]: variant,
            [`mollie-ui-pill--${size}`]: size,
        }, className), ref: ref }, children));
});
//# sourceMappingURL=Pill.js.map